export const locale = {
    id: 'pl',
    prefix: '',
    mailDomain: 'pl',
};
